"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var KeyIcon = function KeyIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.83317 14.1666C7.84484 14.1666 9.529 12.7324 9.91484 10.8333H11.6665V11.6666C11.6665 12.1268 12.0396 12.4999 12.4998 12.4999C12.9601 12.4999 13.3332 12.1268 13.3332 11.6666V10.8333H14.9998V12.4999C14.9998 12.9602 15.3729 13.3333 15.8332 13.3333C16.2934 13.3333 16.6665 12.9602 16.6665 12.4999V10.8333H17.4998V9.16659H9.91484C9.529 7.26742 7.84484 5.83325 5.83317 5.83325C3.53567 5.83325 1.6665 7.70242 1.6665 9.99992C1.6665 12.2974 3.53567 14.1666 5.83317 14.1666ZM5.83317 7.49992C7.2115 7.49992 8.33317 8.62159 8.33317 9.99992C8.33317 11.3783 7.2115 12.4999 5.83317 12.4999C4.45484 12.4999 3.33317 11.3783 3.33317 9.99992C3.33317 8.62159 4.45484 7.49992 5.83317 7.49992Z",
    fill: color
  }));
};

var _default = KeyIcon;
exports.default = _default;